import { render, staticRenderFns } from "./CMS.vue?vue&type=template&id=bab2fed4"
import script from "./CMS.vue?vue&type=script&lang=js"
export * from "./CMS.vue?vue&type=script&lang=js"
import style0 from "./CMS.vue?vue&type=style&index=0&id=bab2fed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports